import { ClaimVrmValidate } from "src/app/interfaces/claim-details";
import { WorkOrder } from "src/app/interfaces/workorder";
import { ClaimService } from "src/app/services/claim.service";
import { WorkitemPreloader } from "src/app/services/workitem-preload.service";
import { range, VrmValidateClaim, VrmValidateData } from "./vrm/VrmValidateData";

export abstract class VrmValidatePreloadBasde implements WorkitemPreloader {
  public abstract readonly workItemType: string;
  private preloadCount: number = 10;

  constructor(
    private claimService: ClaimService
  ) { }

  preload(workitem: WorkOrder): void {
    // Multi
    this.claimService.getVrmValidateData(workitem?.workItemId).subscribe(
      (data: VrmValidateData) => {
        this.loadImages(data);
      },
      err => console.error(err),
      () => { }
    );
  }

  private loadImages(data: VrmValidateData) {
    const upperBound = Math.min(data.claims.length, this.preloadCount);
    data.claims.slice(0, upperBound).map((claim: VrmValidateClaim, index: number) => {
      if (claim.imagesCount > 0) {
        range(1, Math.min(claim.imagesCount, (index > 0 ? 2 : 3)), 1).map(
          (filename) => this.claimService.getClaimImage(claim.claimId, filename).subscribe(
            _ => { },
            err => console.error(err),
            () => { }
          )
        )
      }
    });
  }
}

export class VrmValidatePreloadService extends VrmValidatePreloadBasde {
  public readonly workItemType: string = "VRM_VALIDATION";

  constructor(
    claimService: ClaimService
  ) {
    super(claimService);
  }
}